import script from "./PreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./PreviewModal.vue?vue&type=style&index=0&id=3af2cbe4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3af2cbe4"]])

export default __exports__